const state = {
    user: {
        name:'',
        id:''
    },
    // baseUrl:'http://jiyinapi-test.topgene.cn',//测试服
	baseUrl: 'https://jiyinapi.topgene.cn',//正式服
	// baseUrl:'http://jxapi-test.cvddr.cn'
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js